import {Grid, Typography} from "@mui/material";
import EmbassyLogoUsaLogo from "../../../assets/img/Embassy_logo_USA.png";
import DepartmentOfStateUsaLogo from "../../../assets/img/department_of_state_USA.png";
import React from "react";

import "./../../scss/dashboard-header.scss";

export const DashboardHeader = () => {
    return <div className={"dashboard-header"}>
        <img className={"logo-img additional-right-margin"} src={DepartmentOfStateUsaLogo}/>
        <Typography align={"center"} variant={"subtitle2"}> Реалізовано за пІдтримки США</Typography>
        <img className={"logo-img"} src={EmbassyLogoUsaLogo}/>
    </div>;
};
